import React, {
  lazy,
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import {
  Typography as TypoKvweb,
  Button as ButtonKvweb,
  ColorMono,
  IconButton,
  OutlineXmarkIcon,
  Typography,
  OutlineGlobeIcon,
  OutlineCopyIcon,
  OutlineDownloadIcon,
  SolidFacebookIcon,
  Snackbar,
  OutlineBrowserIcon,
  OutlineShareNodesIcon,
} from "kvweb-ui";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useRouter } from "../../../../utils/hooks/useRouter";
import { RetailContext } from "../../../../contexts/retail/retailMain.context";
import {
  firebaseAndKvaIframeLog,
  firebaseAndKvaLog,
} from "../../../../services/analytics/analytic.service";
import {
  getKVWebDomain,
  getKVWebUrlByDomain,
} from "../../../../services/domain/domainSetting.service";
import { useAdminMerchantContext } from "../../../../contexts/adminMerchant/adminMerchant.context";
import axios from "axios";
import { Spacing, Button, Color } from "kvweb-ui";
import { updateActiveWebsite } from "../../../../services/api/retail/websiteStatusApi";
import { getPlatform } from "../../../../utils/helper";
import {
  BOOKING_HOTEL_PLATFORM,
  BOOKING_PLATFORM,
} from "../../../../utils/constant";
import { useTranslation } from "react-i18next";
import CustomColor from "../../../../utils/overrides/color";

interface IShare {
  isAdminMerchant?: boolean;
  handClose?: () => void;
}
const Share: React.FC<IShare> = ({ isAdminMerchant, handClose }) => {
  const theme = useTheme();
  const router = useRouter();
  const { merchantInfo, branchInfo } = useContext(RetailContext);
  const { retail, updateRetail } = useAdminMerchantContext();
  const [webSiteUrl, setWebSiteUrl] = useState("");
  const [urlQRImage, setUrlQRImage] = useState("");
  const [frameImage, setFrameImage] = useState("");
  const pdfExportComponent = useRef(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openModalWarningUnpublish, setOpenModalWarningUnpublish] =
    useState(false);
  const [copy, setCopy] = useState<boolean>(false);
  const platform = getPlatform();
  const { t } = useTranslation();
  const exportNow = (pdfExportComponent: any) => {
    if (typeof pdfExportComponent !== "undefined") {
      pdfExportComponent?.current?.save();
    }
  };

  const handTracking = () => {
    firebaseAndKvaLog(router.query.platform, "kv_mk_setting_share_download");
    firebaseAndKvaLog(
      router.query.platform,
      "kv_mk_setting_share_download"
    );
  };

  const downloadQr = (e: any) => {
    e.preventDefault();
    handTracking();
    const imageUrl = urlQRImage;
    const xhr = new XMLHttpRequest();
    xhr.open("GET", imageUrl, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (this.status === 200) {
        const url = window.URL.createObjectURL(this.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = imageUrl.split("/").pop() || ""; // Đặt tên cho tệp tải xuống
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    xhr.send();
  };

  const handleExportWithComponent = async () => {
    handTracking();
    const imgResp = await fetch(retail.branchInfo?.url_image || "");

    const blobImage = await imgResp.blob();

    const href = URL.createObjectURL(blobImage);

    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    if (isMobile) {
      //@ts-ignore
      window.downloadImage(retail.branchInfo?.url_image, platform);
      return;
    }
    anchorElement.download = `qrcode-${
      isAdminMerchant
        ? retail?.merchantInfo?.namespace
        : merchantInfo?.namespace || "share"
    }.jpg`;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  };

  async function getUrlQRImage(url: string) {
    const request_url = `${process.env.REACT_APP_QR_CODE}/api/v1/qr-code/download-url`;
    const branchData = isAdminMerchant ? retail.branchInfo : branchInfo;
    const body = {
      uri: url,
      branch_id: branchData?.id,
    };
    const res = await axios.post(request_url, body);
    const urlResponse = res?.data?.link;
    if (urlResponse) {
      console.debug({ urlResponse });
      setUrlQRImage(urlResponse);
    }
  }

  const handGotoQRPage = () => {
    if (isMobile) {
      return;
    }
    if (window) {
      window.open(
        `/retail/share?website_url=${webSiteUrl.replace("https://", "")}`
      );
    }
  };

  const handleClickStopPublished = async () => {
    firebaseAndKvaLog(router.query.platform, "mc_unpublic_cf");
    const result = await updateActiveWebsite({
      is_active: false,
      platform: router.query.platform || "retail",
    });
    if (result) {
      handleUpdateBranchContext();
      handClose && handClose();
    }
  };

  const handleUpdateBranchContext = async () => {
    let newBranchInfo = { ...retail?.branchInfo };
    newBranchInfo.is_active = false;
    await updateRetail({
      key: "branchInfo",
      value: newBranchInfo,
    });
  };

  useEffect(() => {
    const merchantData = isAdminMerchant ? retail.merchantInfo : merchantInfo;
    const kvwebDomain = getKVWebDomain(merchantData);
    const kvwebUrl = getKVWebUrlByDomain(kvwebDomain);
    setWebSiteUrl(kvwebUrl);
  }, [merchantInfo, retail]);

  useEffect(() => {
    const branchData = isAdminMerchant ? retail.branchInfo : branchInfo;
    if (webSiteUrl && isMobile && branchData && !urlQRImage) {
      getUrlQRImage(webSiteUrl);
    }
  }, [webSiteUrl, isMobile, branchInfo, urlQRImage, retail]);

  const handleViewWebSite = () => {
    if (isMobile) {
      //@ts-ignore
      window.openMyWebsite(webSiteUrl, platform);
      return;
    }
    window.open(webSiteUrl, "_blank");
  };

  const handleShareWebsite = (type: string) => {
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - 600) / 2 / systemZoom + dualScreenLeft;
    const top = (height - 800) / 2 / systemZoom + dualScreenTop;
    switch (type) {
      case "facebook":
        if (isMobile) {
          //@ts-ignore
          window.sharePageLink(webSiteUrl, platform);
          if (navigator.share) {
            navigator.share({
              title: retail.merchantInfo?.name,
              url: webSiteUrl,
            });
          }
          break;
        }
        const url = `https://facebook.com/sharer/sharer.php?u=+${encodeURIComponent(
          webSiteUrl
        )}`;
        window.open(
          url,
          "target",
          `width=600,height=800, top=${top}, left=${left}`
        );
        break;
    }
  };

  useEffect(() => {
    setFrameImage(retail.branchInfo?.url_image || "");
  }, [retail]);

  const handleCopyClipboard = () => {
    firebaseAndKvaLog(router.query.platform, "kv_mk_setting_share_copy");
    firebaseAndKvaLog(router.query.platform, "kv_mk_setting_share_copy");
    navigator.clipboard.writeText(webSiteUrl);
    setCopy(true);
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <TypoKvweb textType={"text18S"}>
          {t("COMMON.BUTTON.SHARE_WEBSITE")}
        </TypoKvweb>
        <IconButton btnSize="medium" btnType="text" onClick={handClose}>
          <OutlineXmarkIcon color={Color["black-850"]} />
        </IconButton>
      </Box>
      <Grid
        sx={{
          backgroundColor: "#fff",
          paddingTop: Spacing["space-m"],
        }}
      >
        {/* container */}

        <Grid container>
          {/* left  */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* image group  */}
            <PDFExport
              ref={pdfExportComponent}
              fileName={`qrcode-${
                isAdminMerchant
                  ? retail?.merchantInfo?.namespace
                  : merchantInfo?.namespace || "share"
              }.pdf`}
            >
              <Box
                sx={{
                  [theme.breakpoints.down("md")]: {
                    display: "flex",
                    justifyContent: "center",
                  },
                }}
                // onClick={handGotoQRPage}
              >
                <Box
                  sx={{
                    overflow: "hidden",
                    display: "flex",
                    width: "280px",
                    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.16)",
                    [theme.breakpoints.down("md")]: {
                      width: 200,
                      height: 282,
                    },
                  }}
                >
                  <img
                    src={frameImage}
                    alt="Picture of the author"
                    width={"100%"}
                    // height={358}
                  />
                </Box>
              </Box>
            </PDFExport>
          </Grid>

          {/* right  */}
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              // alignItems: "center",
              [theme.breakpoints.down("md")]: {
                paddingTop: "24px",
              },
              paddingLeft: Spacing["space-l"],
            }}
          >
            <Typography
              textType="text14R"
              sx={{
                color: Color["black-750"],
                // width: 380,
                fontFamily: "Inter",
                lineHeight: "24px",
                [theme.breakpoints.down("md")]: {
                  width: "100%",
                  display: "none",
                },
              }}
            >
              {t("MY_WEBSITE.SHARE_WEBSITE_TO_CUSTOMERS", {
                order_by_platform:
                  platform === BOOKING_PLATFORM
                    ? t("COMMON.BUTTON.BOOKING")
                    : platform === BOOKING_HOTEL_PLATFORM
                    ? t("COMMON.BUTTON.HOTEL")
                    : t("COMMON.BUTTON.SELLING"),
              })}
            </Typography>

            <Box
              sx={{
                paddingY: Spacing["space-xl"],
              }}
            >
              <Typography
                textType="text14S"
                sx={{
                  marginBottom: Spacing["space-s"],
                }}
                color={Color["black-750"]}
              >
                {t("MY_WEBSITE.WEBSITE_URL")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "12px",
                  [theme.breakpoints.down("sm")]: {
                    flexDirection: "column",
                  },
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                  },
                  marginBottom: Spacing["space-s"],
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    px: "12px",
                    alignItems: "center",
                    [theme.breakpoints.down("md")]: {
                      width: "100%",
                    },
                    border: `1px solid ${Color["black-100"]}`,
                  }}
                >
                  <OutlineGlobeIcon color={CustomColor["primary-500"]} />
                  <TypoKvweb
                    textType="text14R"
                    sx={{
                      width: "381px",
                      backgroundColor: ColorMono["color-white"],
                      borderRadius: "4px",
                      color: CustomColor["primary-500"],
                      wordBreak: "break-all",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1,
                      [theme.breakpoints.down("md")]: {
                        width: "100%",
                        marginRight: "4px",
                      },
                    }}
                  >
                    {webSiteUrl}
                  </TypoKvweb>
                </Box>
              </Box>

              <Box
                sx={{
                  [theme.breakpoints.down("md")]: {
                    width: "calc(100%)",
                  },
                }}
              >
                <ButtonKvweb
                  btnType={"fade"}
                  btnSize={"large"}
                  sx={{
                    width: "100%",
                    [theme.breakpoints.up("md")]: {
                      width: "100%",
                    },
                  }}
                  startIcon={<OutlineCopyIcon />}
                  onClick={handleCopyClipboard}
                >
                  <Typography textType="text14S">
                    {t("COMMON.BUTTON.COPY")}
                  </Typography>
                </ButtonKvweb>
              </Box>
            </Box>
            <Suspense>
              <ModalWarningUnPublishWebsite
                open={openModalWarningUnpublish}
                handConfirm={handleClickStopPublished}
                handCancel={() => setOpenModalWarningUnpublish(false)}
              />
            </Suspense>
            {/* button group  */}
            <Box>
              <Typography
                textType="text14S"
                sx={{
                  marginBottom: Spacing["space-s"],
                }}
                color={Color["black-750"]}
              >
                {t("MY_WEBSITE.SHARE_TO_OTHER_CHANNEL")}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  [theme.breakpoints.down("md")]: {
                    width: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    width: 108,
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "50%",
                      boxShadow: "0 0 0 0",
                      marginBottom: Spacing["space-s"],
                      [theme.breakpoints.down("md")]: {
                        // display: "none",
                      },
                    }}
                    onClick={handleExportWithComponent}
                    btnType="fade"
                  >
                    <OutlineDownloadIcon />
                  </IconButton>
                  <TypoKvweb textType="text12R">
                    {t("COMMON.BUTTON.DOWNLOAD_IMAGE")}
                  </TypoKvweb>
                </Box>

                {/* Facebook */}

                <Box
                  sx={{
                    textAlign: "center",
                    width: 108,
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "50%",
                      boxShadow: "0 0 0 0",
                      marginBottom: Spacing["space-s"],
                      [theme.breakpoints.down("md")]: {
                        // display: "none",
                      },
                    }}
                    onClick={() => handleShareWebsite("facebook")}
                    btnType="fade"
                  >
                    {isMobile ? (
                      <OutlineShareNodesIcon />
                    ) : (
                      <SolidFacebookIcon />
                    )}
                  </IconButton>
                  <TypoKvweb textType="text12R">
                    {isMobile ? "Chia sẻ" : "Facebook"}
                  </TypoKvweb>
                </Box>

                {/* View Website */}
                <Box
                  sx={{
                    textAlign: "center",
                    width: 108,
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "50%",
                      boxShadow: "0 0 0 0",
                      marginBottom: Spacing["space-s"],
                      [theme.breakpoints.down("md")]: {
                        // display: "none",
                      },
                    }}
                    onClick={handleViewWebSite}
                    btnType="fade"
                  >
                    <OutlineBrowserIcon />
                  </IconButton>
                  <TypoKvweb textType="text12R">
                    {t("COMMON.BUTTON.VIEW_WEBSITE")}
                  </TypoKvweb>
                </Box>
                <Box
                  sx={{
                    display: "none",
                    [theme.breakpoints.down("md")]: {
                      display: "none",
                      width: "100%",
                    },
                  }}
                >
                  {/* <a download={true} href={urlQRImage} target="_blank"> */}
                  <Button
                    variant="contained"
                    sx={{
                      width: "168px",
                      background: "#28A745",
                      fontSize: 14,
                      fontWeight: 700,
                      fontFamily: "Inter",
                      "&:hover": {
                        background: "#218838",
                      },
                      padding: "8px 26px",
                      boxShadow: "0 0 0 0",
                      [theme.breakpoints.down("md")]: {
                        width: "100%",
                      },
                    }}
                    onClick={downloadQr}
                  >
                    Tải mã QR
                  </Button>

                  <ButtonKvweb
                    startIcon={<IconUnpublish />}
                    btnType={"outlined"}
                    onClick={() => {
                      setOpenModalWarningUnpublish(true);
                      firebaseAndKvaLog(router.query.platform, "mc_unpublic");
                    }}
                    sx={{ width: "100%", mt: Spacing["space-xxl"] }}
                    btnColor={"red"}
                    btnSize={"large"}
                  >
                    Ngừng xuất bản
                  </ButtonKvweb>
                  {/* </a> */}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <Snackbar
        open={copy}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={1000}
        onClose={() => setCopy(false)}
      >
        <Typography>{t("COMMON.COPY_SUCCESSFULLY")}</Typography>
      </Snackbar>
    </Box>
  );
};

const ModalWarningUnPublishWebsite = lazy(
  () =>
    import(
      "../../../AdminMerchant/Components/Modal/ModalWarningUnPublishWebsite"
    )
);

export function IconStop() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1875 17C7.46875 17 7.75 17.2812 7.75 17.5625C7.75 17.8789 7.46875 18.125 7.1875 18.125H3.8125C2.23047 18.125 1 16.8945 1 15.3125V5.1875C1 3.64062 2.23047 2.375 3.8125 2.375H7.1875C7.46875 2.375 7.75 2.65625 7.75 2.9375C7.75 3.25391 7.46875 3.5 7.1875 3.5H3.8125C2.86328 3.5 2.125 4.27344 2.125 5.1875V15.3125C2.125 16.2617 2.86328 17 3.8125 17H7.1875ZM18.6484 9.47656C18.8594 9.6875 19 9.96875 19 10.25C19 10.5664 18.8594 10.8477 18.6484 11.0586L14.1484 15.5586C13.832 15.875 13.3398 15.9805 12.918 15.8047C12.4961 15.6289 12.25 15.207 12.25 14.75V12.5H7.1875C6.23828 12.5 5.5 11.7617 5.5 10.8125V9.6875C5.5 8.77344 6.23828 8 7.1875 8H12.25V5.75C12.25 5.32812 12.4961 4.90625 12.918 4.73047C13.3398 4.55469 13.832 4.66016 14.1484 4.97656L18.6484 9.47656ZM13.375 14.75L17.8398 10.25L13.3398 5.75L13.375 9.125H7.1875C6.87109 9.125 6.625 9.40625 6.625 9.6875V10.8125C6.625 11.1289 6.87109 11.375 7.1875 11.375H13.375V14.75Z"
        fill="#E94235"
      />
    </svg>
  );
}
export function IconUnpublish() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.53957 18.1647C8.82082 18.1647 9.10207 18.4459 9.10207 18.7272C9.10207 19.0436 8.82082 19.2897 8.53957 19.2897H5.16457C3.58254 19.2897 2.35207 18.0592 2.35207 16.4772V6.35217C2.35207 4.8053 3.58254 3.53967 5.16457 3.53967H8.53957C8.82082 3.53967 9.10207 3.82092 9.10207 4.10217C9.10207 4.41858 8.82082 4.66467 8.53957 4.66467H5.16457C4.21535 4.66467 3.47707 5.43811 3.47707 6.35217V16.4772C3.47707 17.4264 4.21535 18.1647 5.16457 18.1647H8.53957ZM20.0005 10.6412C20.2114 10.8522 20.3521 11.1334 20.3521 11.4147C20.3521 11.7311 20.2114 12.0123 20.0005 12.2233L15.5005 16.7233C15.1841 17.0397 14.6919 17.1451 14.27 16.9694C13.8482 16.7936 13.6021 16.3717 13.6021 15.9147V13.6647H8.53957C7.59035 13.6647 6.85207 12.9264 6.85207 11.9772V10.8522C6.85207 9.93811 7.59035 9.16467 8.53957 9.16467H13.6021V6.91467C13.6021 6.4928 13.8482 6.07092 14.27 5.89514C14.6919 5.71936 15.1841 5.82483 15.5005 6.14124L20.0005 10.6412ZM14.7271 15.9147L19.1919 11.4147L14.6919 6.91467L14.7271 10.2897H8.53957C8.22316 10.2897 7.97707 10.5709 7.97707 10.8522V11.9772C7.97707 12.2936 8.22316 12.5397 8.53957 12.5397H14.7271V15.9147Z"
        fill="#E94235"
      />
    </svg>
  );
}

export const IconBack = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7912 5.63579H3.48286L7.54953 1.56913C7.87453 1.24413 7.87453 0.710793 7.54953 0.385793C7.47244 0.30854 7.38086 0.24725 7.28005 0.205432C7.17924 0.163615 7.07117 0.14209 6.96203 0.14209C6.85289 0.14209 6.74482 0.163615 6.64401 0.205432C6.5432 0.24725 6.45163 0.30854 6.37453 0.385793L0.882864 5.87746C0.805611 5.95455 0.744321 6.04613 0.702503 6.14694C0.660685 6.24775 0.63916 6.35582 0.63916 6.46496C0.63916 6.5741 0.660685 6.68217 0.702503 6.78298C0.744321 6.88379 0.805611 6.97537 0.882864 7.05246L6.37453 12.5441C6.45168 12.6213 6.54327 12.6825 6.64408 12.7242C6.74488 12.766 6.85292 12.7875 6.96203 12.7875C7.07114 12.7875 7.17918 12.766 7.27998 12.7242C7.38079 12.6825 7.47238 12.6213 7.54953 12.5441C7.62668 12.467 7.68788 12.3754 7.72964 12.2746C7.77139 12.1738 7.79288 12.0657 7.79288 11.9566C7.79288 11.8475 7.77139 11.7395 7.72964 11.6387C7.68788 11.5379 7.62668 11.4463 7.54953 11.3691L3.48286 7.30246H12.7912C13.2495 7.30246 13.6245 6.92746 13.6245 6.46913C13.6245 6.01079 13.2495 5.63579 12.7912 5.63579Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};
export const IconRevert = () => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1517 12.5633C11.9745 13.7417 10.4251 14.4756 8.76758 14.6398C7.11001 14.8041 5.44677 14.3885 4.06124 13.4639C2.6757 12.5394 1.65359 11.163 1.16904 9.56939C0.684494 7.97574 0.76749 6.26338 1.40389 4.72406C2.04029 3.18474 3.19071 1.91369 4.65917 1.12746C6.12762 0.34123 7.82325 0.0884692 9.45717 0.412238C11.0911 0.736007 12.5622 1.61627 13.6199 2.90307C14.6776 4.18986 15.2564 5.80357 15.2577 7.46925H13.4577C13.4588 6.21987 13.0266 5.00877 12.2348 4.04232C11.4431 3.07586 10.3406 2.41386 9.11548 2.16912C7.8903 1.92438 6.61817 2.11204 5.51586 2.70013C4.41354 3.28822 3.54926 4.24034 3.07027 5.39426C2.59129 6.54817 2.52725 7.83248 2.88906 9.02832C3.25088 10.2242 4.01616 11.2575 5.0545 11.9524C6.09285 12.6472 7.34 12.9605 8.58344 12.8388C9.82688 12.7172 10.9897 12.1681 11.8737 11.2853L13.1517 12.5633ZM10.7577 7.46925H17.9577L14.3577 11.0693L10.7577 7.46925Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default Share;
